import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["xlink:href"]
const _hoisted_3 = ["width", "height", "viewBox"]
const _hoisted_4 = ["xlink:href"]
const _hoisted_5 = ["width", "height", "viewBox"]
const _hoisted_6 = ["xlink:href"]

import { computed } from "vue";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import type { SvgIcons } from "./types";
import { iconNames } from "../typography/storiesIconName";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-icon',
  props: {
    width: {},
    height: {},
    name: {},
    isInStorybook: { type: Boolean, default: false },
    swapBreakpoint: { default: "sm2" }
  },
  setup(__props: any) {

const props = __props;

const iconSize = {
    thin: 16,
    regular: 24,
};

const isSizeSet = computed((): boolean => !!props.width && !!props.height);

const isThin = computed((): boolean => props.width === iconSize.thin && props.height === iconSize.thin);

const isRegular = computed((): boolean => props.width === iconSize.regular && props.height === iconSize.regular);

const getViewBox = (width: number, height: number): string => `0 0 ${height} ${width}`;

const getHref = (iconName: string): string =>
    props.isInStorybook
        ? `/images/svg-icons/${iconName}.svg#${iconName}`
        : `/frontend/img/svg-icons/${iconName}.svg#${iconName}`;

const resolvedThinIconName = computed(() => {
    const thinIconName = `${props.name}-thin`;

    return iconNames.includes(thinIconName as SvgIcons) ? thinIconName : props.name;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["ds-icon", [
            !isSizeSet.value && `ds-icon--${_ctx.swapBreakpoint.toString()}`,
            { 'ds-icon--thin': isThin.value },
            { 'ds-icon--regular': isRegular.value },
        ]])
  }, [
    (isSizeSet.value)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          width: _ctx.width,
          height: _ctx.height,
          viewBox: getViewBox(_ctx.width, _ctx.height)
        }, [
          _createElementVNode("use", {
            "xlink:href": getHref(_ctx.name)
          }, null, 8, _hoisted_2)
        ], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_openBlock(), _createElementBlock("svg", {
            width: iconSize.thin,
            height: iconSize.thin,
            viewBox: getViewBox(iconSize.thin, iconSize.thin),
            class: "ds-icon__thin"
          }, [
            _createElementVNode("use", {
              "xlink:href": getHref(resolvedThinIconName.value)
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3)),
          (_openBlock(), _createElementBlock("svg", {
            width: iconSize.regular,
            height: iconSize.regular,
            viewBox: getViewBox(iconSize.regular, iconSize.regular),
            class: "ds-icon__regular"
          }, [
            _createElementVNode("use", {
              "xlink:href": getHref(_ctx.name)
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_5))
        ], 64))
  ], 2))
}
}

})